/**
 * Server returns f/b value for every block of 30 minutes.
 */
export const FREE_BUSY_BLOCK_SIZE_IN_MIN = 30;
